import React from "react";
import twoweeks from "../../components/twoweeks.jpeg";
import Two_Week_Method from "./Two_Week_Method_-_14-Day_Deletion_Method.pdf";

function TwoWeeksMethod() {
  return (
    <div className="container">
      <div className="banner">
        <img src={twoweeks} alt="" />
      </div>
      <div className="container_body">
        <div className="course">
          <h1>2 Week Method</h1>
          <p>
            <a href="https://drive.google.com/file/d/1zTVXVpbucTxKq9RfPEWg2lEdOcCLJ9ZS/view?usp=drive_link">
              14-Day Credit Deletion Method
            </a>
          </p>
        </div>
        <div className="downloads">
          <h3>Downloads</h3>
          <a href={Two_Week_Method}>
            Two_Week_Method_-_14-Day_Deletion_Method.pdf
          </a>
        </div>
      </div>
    </div>
  );
}

export default TwoWeeksMethod;
